import { render, staticRenderFns } from "./CheckboxText.vue?vue&type=template&id=31bfe043&"
import script from "./CheckboxText.vue?vue&type=script&lang=js&"
export * from "./CheckboxText.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports